import { Route, Routes } from "react-router-dom";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";
import {
  AdminCreate,
  AdminList,
  ResetPassword,
  Dashboard,
  ForgetPassword,
  Login,
  OrganisationCreate,
  OrganisationList,
  AdminEdit,
  OrganisationEdit,
  GymList,
  GymCreate,
  StaffList,
  StaffCreate,
  StaffEdit,
  Licenses,
  Billing,
  PaymentDetails,
  ExerciseList,
  ExerciseCreate,
  SessionCreate,
  SessionList,
  Schedule,
  ExerciseEdit,
  SessionFormatBuilder,
  SessionBlocksBuilder,
  SessionMetricsBuilder,
  SessionSummaryBuilder,
  SessionPreview,
  GymLicenseSelection,
  DeviceList,
  PaymentDetailsList,
  ThemeSettings,
} from "../pages";
import NotFound from "../components/NotFound";
import SessionView from "../pages/workouts/Sessions/SessionView";
import LoginToken from "../pages/admin/LoginToken";
import SessionSummaryTable from "../pages/workouts/Sessions/SessionSummaryTable";
import { CreateTheme } from "../pages/Settings";

export const adminRoutes = {
  dashboard: "/",
  login: "/login",
  LoginToken: "/login-token/:token",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password/:token",
  adminList: "/admin",
  adminCreate: "/admin/create",
  adminEdit: "/admin/:id",
  deviceList: "/device",
  organisationList: "/organisation",
  organisationCreate: "/organisation/create",
  organisationEdit: "/organisation/:orgid",
  gymList: "/gym",
  gymCreate: "/gym/create",
  gymEdit: "/gym/:gymid",
  gymAssignLicenses: "/gym/assign-license/:gymid",
  staffList: "/staff",
  staffCreate: "/staff/create",
  staffEdit: "/staff/:staffid",
  licenses: "/licenses",
  billing: "/billing",
  paymentList: "/payment-details",
  paymentCreate: "/payment-details/create",
  paymentEdit: "/payment-details/edit/:paymentId",
  exerciseList: "/exercise",
  exerciseCreate: "/exercise/create",
  exerciseEdit: "/exercise/:exerciseid",
  sessionList: "/session",
  sessionCreate: "/session/create",
  sessionEdit: "/session/:sessionid",
  sessionFormatBuilder: "/session/format-builder/:sessionid",
  sessionBlocksBuilder: "/session/blocks-builder/:sessionid",
  sessionMetricsBuilder: "/session/metrics-builder/:sessionid",
  sessionSummaryBuilder: "/session/summary-builder/:sessionid",
  sessionPreview: "/session/preview/:sessionid",
  sessionView: "/session/view/:sessionid",
  themeSettings: "/theme-settings",
  schedule: "/schedule",
  createTheme: "/theme-settings/create",
  editTheme: "/theme-settings/:id",

  sessionSummaryTable: "/session/summary-table/:sessionid"
};

const AdminRouter = () => {
  return (
    <Routes>
      <Route path={adminRoutes.LoginToken} element={<LoginToken />} />


      <Route element={<UnprotectedRoute />}>
        <Route path={adminRoutes.login} element={<Login />} />
        <Route path={adminRoutes.forgetPassword} element={<ForgetPassword />} />
        <Route path={adminRoutes.resetPassword} element={<ResetPassword />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path={adminRoutes.dashboard} element={<Dashboard />} />
        <Route path={adminRoutes.adminList} element={<AdminList />} />
        <Route path={adminRoutes.adminCreate} element={<AdminCreate />} />
        <Route path={adminRoutes.adminEdit} element={<AdminEdit />} />
        <Route path={adminRoutes.deviceList} element={<DeviceList />} />
        <Route path={adminRoutes.themeSettings} element={<ThemeSettings />} />
        <Route path={adminRoutes.createTheme} element={<CreateTheme />} />
        <Route path={adminRoutes.editTheme} element={<CreateTheme />} />
        <Route
          path={adminRoutes.organisationList}
          element={<OrganisationList />}
        />
        <Route
          path={adminRoutes.organisationCreate}
          element={<OrganisationCreate />}
        />
        <Route
          path={adminRoutes.organisationEdit}
          element={<OrganisationEdit />}
        />
        <Route path={adminRoutes.gymList} element={<GymList />} />
        <Route path={adminRoutes.gymCreate} element={<GymCreate />} />
        <Route path={adminRoutes.gymEdit} element={<GymCreate />} />
        <Route
          path={adminRoutes.gymAssignLicenses}
          element={<GymLicenseSelection />}
        />
        <Route path={adminRoutes.staffList} element={<StaffList />} />
        <Route path={adminRoutes.staffCreate} element={<StaffCreate />} />
        <Route path={adminRoutes.staffEdit} element={<StaffEdit />} />
        <Route path={adminRoutes.licenses} element={<Licenses />} />
        <Route path={adminRoutes.billing} element={<Billing />} />
        <Route path={adminRoutes.paymentList} element={<PaymentDetailsList />} />
        <Route path={adminRoutes.paymentCreate} element={<PaymentDetails />} />
        <Route path={adminRoutes.paymentEdit} element={<PaymentDetails />} />
        <Route path={adminRoutes.exerciseList} element={<ExerciseList />} />
        <Route path={adminRoutes.exerciseCreate} element={<ExerciseCreate />} />
        <Route path={adminRoutes.exerciseEdit} element={<ExerciseEdit />} />
        <Route path={adminRoutes.sessionList} element={<SessionList />} />
        <Route path={adminRoutes.sessionCreate} element={<SessionCreate />} />
        <Route path={adminRoutes.sessionEdit} element={<SessionCreate />} />
        <Route
          path={adminRoutes.sessionFormatBuilder}
          element={<SessionFormatBuilder />}
        />
        <Route
          path={adminRoutes.sessionBlocksBuilder}
          element={<SessionBlocksBuilder />}
        />
        <Route
          path={adminRoutes.sessionMetricsBuilder}
          element={<SessionMetricsBuilder />}
        />
        <Route
          path={adminRoutes.sessionSummaryBuilder}
          element={<SessionSummaryBuilder />}
        />
        <Route
          path={adminRoutes.sessionPreview}
          element={<SessionPreview />}
        />
        <Route
          path={adminRoutes.sessionView}
          element={<SessionView />}
        />

        <Route
          path={adminRoutes.sessionSummaryTable}
          element={<SessionSummaryTable />}
        />
        <Route path={adminRoutes.schedule} element={<Schedule />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AdminRouter;
